<script setup>
  defineProps({
    SeatTotalTableData: { type: Array, default: () => [] },
  });
</script>
<template>
  <div style="margin-top: 5px;">
    <div class="detail-row">
      <span class="detail-label">午前</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: SeatTotalTableData[0]?.morningEmptyRate + '%',
          background: 'var(--accent-blue)',
        }"></div>
      </div>
      <span class="detail-value">{{ SeatTotalTableData[0]?.morningEmptyRate }}%</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">午後</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: SeatTotalTableData[0]?.afternoonEmptyRate + '%',
          background: 'var(--brand-color)',
        }"></div>
      </div>
      <span class="detail-value">{{ SeatTotalTableData[0]?.afternoonEmptyRate }}%</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">夜</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: SeatTotalTableData[0]?.nightEmptyRate + '%',
          background: 'var(--accent-purple)',
        }"></div>
      </div>
      <span class="detail-value">{{ SeatTotalTableData[0]?.nightEmptyRate }}%</span>
    </div>
  </div>
</template>